import * as DataContracts from "./routes/data-contracts";
import type { V5Draft } from "./routes/V5DraftRoute";

export type { V5Draft as Routes, DataContracts };

// 수동 업데이트 X, npm run generate:api:versioned 명령어 사용해주세요.
export const version = "v5draft";

export const toApiPath = (path: string) => {
  return `/${version}${path}`;
};
